/**
 * @param {number|string} value
 * @returns {string}
 */
const CareerFormation = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const score = Number(value) * 100;

  if (isNaN(score)) return "";

  if (score < 8) return "*";
  if (score == 8) return "**";
  if (score > 8 && score <= 9) return "***";
  if (score > 9 && score <= 10) return "****";
  return "*****";
};

export default CareerFormation;